import type { IconProps } from '../types/IconProps.ts';
export const PauseSquare: IconProps = {
    name: 'PauseSquare',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="M10 9v6M14 9v6" />`,
    ]
};